<template lang="pug">
  .simple-review-quotes-carousel.container
    .row.xs-f-small.md-f-medium.lg-f-small(justify="center" style="height: 100%")
      .content-wrap.xs-12
        .carousel-wrap.xs-12
          simple-carousel(:options="carouselOptions" tabindex="0")
            review-quote(v-for="(quote, index) in quotes" :key="index" v-bind="quote")
                
      .xs-12.text-center(v-if="cta.text")
        a.mr-btn.sm-f-xxsmall.md-f-xxsmall.lg-f-xsmall.max-at-tweak(v-if="solidCtaButton" @click.prevent="onLinkClick" :href="cta.url" data-mr-ass="simple-reviews-quotes-carousel-cta-button" tabindex="0" role="button") {{cta.text}}
        a.cta-button.mr-btn.btn-secondary.sm-f-xxsmall.md-f-xxsmall.lg-f-xsmall.max-at-tweak(v-else @click.prevent="onLinkClick" :href="cta.url" data-mr-ass="simple-reviews-quotes-carousel-cta-button" tabindex="0" role="button") {{cta.text}}
</template>
<script>
  import SimpleCarousel from '@components/SimpleCarousel';
  import ReviewQuote from '@components/ReviewQuote';

  export default {
    name: "SimpleReviewQuotesCarousel",

    components: {
      SimpleCarousel,
      ReviewQuote,
    },

    props: {
      ctaClickEventName: {
        type: String,
        default() {
          return '';
        },
      },
      cta: {
        type: Object,
        default() {
          return {
            url: '',
            text: '',
          };
        },
      },
      quotes: {
        type: Array,
        default() {
          return [];
        },
      },
      solidCtaButton: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },

    computed: {
      carouselOptions() {
        return {
          autoplay: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          dots: true,
          arrows: false,
        };
      },
    },

    methods: {
      onLinkClick() {
        this.trackMREventAndRedirect(this.ctaClickEventName, this.cta.url);
      }
    },
  };
</script>
<style lang="stylus">
  .simple-review-quotes-carousel
    padding 28px 0px
    display block
    max-width 1300px
    margin 0 auto

    @media mq-mobile
      height 320px
    
    .content-wrap
      .carousel-wrap
        margin 0em auto

        .review-quote
          padding 10px 40px
        
        .simple-carousel
          .carousel
            .slick-slider
              margin-bottom 40px
              width 100%
              
              .slick-list
                padding-bottom 10px
                
                .slick-track
                  top 10px

              .slick-dots
                bottom -20px
                
                li
                  width 12px
                  margin 0 1px
                  button
                    &:before
                      font-size 28px
              
                    &:focus
                      outline unset

    .cta-button
      margin-top 6px
      cursor pointer
      background-color transparent
      border-width 1px
    
      &:hover
        color #853585
</style>
